<div class="errors__body">
  <div class="errors__content">
    @for (group of errorGroups; track group) {
      <div class="errors__error-group card text-body">
        <header class="card-header">
          <strong class="d-flex align-items-center">
            <span>{{ group.header | portalTranslate }}</span>
            @if (group.errors.length > 1) {
              <span class="badge text-bg-danger ms-1">
                {{ group.errors.length }}
              </span>
            }
          </strong>
        </header>
        <ul class="list-group list-group-flush">
          @for (error of group.errors; track error; let index = $index) {
            <li class="errors__error list-group-item">
              @if (group.errors.length > 1) {
                <span class="errors__error-index">#{{ index + 1 }}</span>
              }
              <dl>
                <dt>{{ 'common.errors.errorId' | portalTranslate }}</dt>
                <dd>{{ error.id | translate }}</dd>
                @if (error.description?.details?.exception; as exception) {
                  <dt>{{ 'alert.detail.exception' | portalTranslate }}</dt>
                  <dd>
                    <ng-template
                      [ngTemplateOutlet]="exceptionTmpl"
                      [ngTemplateOutletContext]="{ options: { limit: 333, showAll: false } }"
                    ></ng-template>
                    <ng-template #exceptionTmpl let-options="options">
                      @if (exception.length > options.limit && options.showAll === false; as sa) {
                        <code style="white-space: pre-line">
                          {{ exception.substr(0, options.limit) | portalTranslate }}
                          {{ '...' }}
                          <div>
                            <button class="btn btn--portal-link btn-sm" (click)="options.showAll = true">
                              {{ 'generic.showAll' | translate }}
                            </button>
                          </div>
                        </code>
                      } @else {
                        <code style="white-space: pre-line">{{ exception | portalTranslate }}</code>
                      }
                    </ng-template>
                  </dd>
                }
                @if (error.description?.details?.resultCode; as resultCode) {
                  <dt>{{ 'alert.detail.resultCode' | portalTranslate }}</dt>
                  <dd>{{ resultCode | portalTranslate }}</dd>
                }
                @if (error.description?.details?.message; as message) {
                  <dt>{{ 'alert.detail.message' | portalTranslate }}</dt>
                  <dd>{{ message | portalTranslate }}</dd>
                }
                @if (error.description?.details?.violatingFields; as fields) {
                  <dt>{{ 'alert.detail.violatingFields' | translate }}</dt>
                  <dd>
                    <dl class="ps-3 pt-2">
                      @for (field of fields; track field) {
                        <dt>{{ field['name'] }}</dt>
                        <dd>
                          @for (item of field | keyvalue; track item; let last = $last) {
                            @if (item.key !== 'name') {
                              {{ item.key }}: {{ item.value }} {{ last ? '' : '|' }}
                            }
                          }
                        </dd>
                      }
                    </dl>
                  </dd>
                }
                @if (error.description?.details?.hint; as hint) {
                  <dt>{{ 'alert.detail.hint' | translate }}</dt>
                  <dd>{{ hint | portalTranslate }}</dd>
                }
                @if (error.description?.details?.details; as details) {
                  <dt>{{ 'alert.detail.details' | portalTranslate }}</dt>
                  <dd>{{ details | portalTranslate }}</dd>
                }
                @if (error.description?.details?.raw; as raw) {
                  @if (raw.indexOf('<html') > -1) {
                    <iframe
                      class="errors__raw-iframe"
                      #iframe
                      (load)="setIframeContent(iframe, raw)"
                    ></iframe>
                  } @else {
                    <code class="text-body">{{ raw }}</code>
                  }
                }
              </dl>
            </li>
          }
        </ul>
      </div>
    }
  </div>
</div>
